import axios from "axios";

const noVersionClient = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_NO_VERSION,
});

noVersionClient.defaults.timeout = 120000;

export default noVersionClient;
